import PropTypes from 'prop-types';
var propTypes = {
  cascadeStyle: PropTypes.bool,
  children: PropTypes.node,
  component: PropTypes.elementType,
  customStyle: PropTypes.any,
  roundMargin: PropTypes.string,
  sharpMargin: PropTypes.string
};
export default propTypes;